import React, { Component } from 'react';
import ReactExport from "react-export-excel";
import Moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class SuscriptorExcel extends Component {
    constructor(props)
    {
        super(props);
    }

    props = {
        dataReport: []
      }

    render() {
        return (
            <ExcelFile filename="SUSCRIPTOR_FOOTER" element={<a href="#" className="btnReporte_Log">REPORTE</a>}>
                <ExcelSheet data={this.props.dataReport} name="DATA">
                    <ExcelColumn label="CORREO ELECTRÓNICO" value="sfoo_Correo"/>
                    <ExcelColumn label="SECCIÓN ORIGEN" value="sfoo_Seccion"/>                    
                    <ExcelColumn label="IP" value="sfoo_IpCreacion"/>    
                    <ExcelColumn label="FECHA DE REGISTRO" value={(col) => Moment(col.sfoo_FechaCreacion).format('DD/MM/YYYY')}/>                        
                </ExcelSheet>
            </ExcelFile>
        )
    }
}
